// extracted by mini-css-extract-plugin
export var timeline = "timeline-module--timeline--mDer4";
export var upButton = "timeline-module--up-button--I71HA";